const DIM = { className: "dim" };

const tmtRibs = () => {
  const ribs = [];
  for (let i = 0; i < 14; i++) {
    const a = (i / 14) * Math.PI * 2;
    ribs.push(
      <line
        key={i}
        x1={60 + 24 * Math.cos(a)}
        y1={56 + 24 * Math.sin(a)}
        x2={60 + 31 * Math.cos(a)}
        y2={56 + 31 * Math.sin(a)}
      />
    );
  }
  return ribs;
};

const _CC = ["9", "1"];
const _SEG = ["98", "68", "76", "01", "20"];

export const phoneRaw = () => _CC.join("") + _SEG.join("");

export const phoneDisplay = () => {
  const n = phoneRaw();
  return `+${n.slice(0, 2)} ${n.slice(2, 7)} ${n.slice(7)}`;
};

export const phoneHref = () => `tel:+${phoneRaw()}`;

export const CONTACT = {
  firm: "AHUJA BROTHERS",
  owner: "RINKU AHUJA",
  email: "rinkuahuja72@gmail.com",
  address: "Y-257, LOHA MANDI, NARAINA, NEW DELHI – 110028",
};

export const waLink = (product) => {
  const msg = product
    ? `Hi Ahuja Brothers, please share today's rate for ${product}. Section/size and quantity: `
    : "Hi Ahuja Brothers, please share today's rate.";
  return `https://wa.me/${phoneRaw()}?text=${encodeURIComponent(msg)}`;
};

export const PRODUCTS = [
  {
    id: "angles",
    name: "MS ANGLES",
    spec: "25×25×3 — 100×100×10 MM",
    draw: () => (
      <>
        <path className="prof" d="M34 22 V98 H86 V86 H46 V22 Z" />
        <g {...DIM}>
          <line x1="34" y1="108" x2="86" y2="108" />
          <line x1="34" y1="104" x2="34" y2="112" />
          <line x1="86" y1="104" x2="86" y2="112" />
          <text x="60" y="106" textAnchor="middle">b</text>
          <line x1="24" y1="22" x2="24" y2="98" />
          <line x1="20" y1="22" x2="28" y2="22" />
          <line x1="20" y1="98" x2="28" y2="98" />
          <text x="15" y="60" textAnchor="middle" transform="rotate(-90 15 60)">d</text>
        </g>
      </>
    ),
  },
  {
    id: "channels",
    name: "MS CHANNELS",
    spec: "75×40 — 400×100 MM",
    draw: () => (
      <>
        <path className="prof" d="M86 24 H38 V96 H86 V84 H50 V36 H86 Z" />
        <g {...DIM}>
          <line x1="38" y1="106" x2="86" y2="106" />
          <line x1="38" y1="102" x2="38" y2="110" />
          <line x1="86" y1="102" x2="86" y2="110" />
          <text x="62" y="104" textAnchor="middle">b</text>
          <line x1="28" y1="24" x2="28" y2="96" />
          <line x1="24" y1="24" x2="32" y2="24" />
          <line x1="24" y1="96" x2="32" y2="96" />
          <text x="19" y="60" textAnchor="middle" transform="rotate(-90 19 60)">h</text>
        </g>
      </>
    ),
  },
  {
    id: "sheets",
    name: "SHEETS",
    spec: "HR · CR · GP · METRO",
    draw: () => (
      <>
        <path className="prof" d="M18 66 L92 50 L104 54 L30 70 Z" />
        <path className="prof" d="M30 70 L104 54 L104 58 L30 74 Z" />
        <g {...DIM}>
          <line x1="30" y1="92" x2="104" y2="92" />
          <line x1="30" y1="88" x2="30" y2="96" />
          <line x1="104" y1="88" x2="104" y2="96" />
          <text x="67" y="90" textAnchor="middle">w</text>
          <line x1="112" y1="54" x2="112" y2="58" />
          <text x="116" y="58">t</text>
        </g>
      </>
    ),
  },
  {
    id: "plates",
    name: "PLATES",
    spec: "5 — 100 MM THK",
    draw: () => (
      <>
        <path className="prof" d="M28 44 H88 V76 H28 Z" />
        <g {...DIM}>
          <line x1="28" y1="92" x2="88" y2="92" />
          <line x1="28" y1="88" x2="28" y2="96" />
          <line x1="88" y1="88" x2="88" y2="96" />
          <text x="58" y="90" textAnchor="middle">w</text>
          <line x1="98" y1="44" x2="98" y2="76" />
          <line x1="94" y1="44" x2="102" y2="44" />
          <line x1="94" y1="76" x2="102" y2="76" />
          <text x="107" y="62" textAnchor="middle" transform="rotate(-90 107 62)">t</text>
        </g>
      </>
    ),
  },
  {
    id: "round-bars",
    name: "ROUND BARS",
    spec: "6 — 100 MM Ø",
    draw: () => (
      <>
        <circle className="prof" cx="60" cy="54" r="27" />
        <g className="cl">
          <line x1="60" y1="18" x2="60" y2="90" />
          <line x1="24" y1="54" x2="96" y2="54" />
        </g>
        <g {...DIM}>
          <line x1="33" y1="102" x2="87" y2="102" />
          <line x1="33" y1="98" x2="33" y2="106" />
          <line x1="87" y1="98" x2="87" y2="106" />
          <text x="60" y="100" textAnchor="middle">Ø</text>
        </g>
      </>
    ),
  },
  {
    id: "tmt-bars",
    name: "TMT BARS",
    spec: "Fe500 · Fe550 — 8—32 MM",
    draw: () => (
      <>
        <g className="prof">
          <circle cx="60" cy="56" r="24" />
          {tmtRibs()}
        </g>
        <g className="cl">
          <line x1="60" y1="16" x2="60" y2="96" />
          <line x1="20" y1="56" x2="100" y2="56" />
        </g>
        <g {...DIM}>
          <line x1="29" y1="104" x2="91" y2="104" />
          <line x1="29" y1="100" x2="29" y2="108" />
          <line x1="91" y1="100" x2="91" y2="108" />
          <text x="60" y="102" textAnchor="middle">Ø</text>
        </g>
      </>
    ),
  },
  {
    id: "flats",
    name: "FLATS",
    spec: "20×3 — 100×12 MM",
    draw: () => (
      <>
        <path className="prof" d="M14 52 H106 V66 H14 Z" />
        <g {...DIM}>
          <line x1="14" y1="84" x2="106" y2="84" />
          <line x1="14" y1="80" x2="14" y2="88" />
          <line x1="106" y1="80" x2="106" y2="88" />
          <text x="60" y="82" textAnchor="middle">w</text>
          <line x1="112" y1="52" x2="112" y2="66" />
          <line x1="108" y1="52" x2="116" y2="52" />
          <line x1="108" y1="66" x2="116" y2="66" />
          <text x="60" y="44" textAnchor="middle">t</text>
        </g>
      </>
    ),
  },
  {
    id: "square-bars",
    name: "SQUARE BARS",
    spec: "8 — 50 MM",
    draw: () => (
      <>
        <path className="prof" d="M36 32 H84 V80 H36 Z" />
        <g className="cl">
          <line x1="60" y1="22" x2="60" y2="90" />
          <line x1="26" y1="56" x2="94" y2="56" />
        </g>
        <g {...DIM}>
          <line x1="36" y1="96" x2="84" y2="96" />
          <line x1="36" y1="92" x2="36" y2="100" />
          <line x1="84" y1="92" x2="84" y2="100" />
          <text x="60" y="94" textAnchor="middle">a</text>
        </g>
      </>
    ),
  },
  {
    id: "pipes",
    name: "PIPES",
    spec: "15 — 200 MM NB",
    draw: () => (
      <>
        <circle className="prof" cx="60" cy="54" r="30" />
        <circle className="prof" cx="60" cy="54" r="19" />
        <g className="cl">
          <line x1="60" y1="14" x2="60" y2="94" />
          <line x1="20" y1="54" x2="100" y2="54" />
        </g>
        <g {...DIM}>
          <line x1="30" y1="102" x2="90" y2="102" />
          <line x1="30" y1="98" x2="30" y2="106" />
          <line x1="90" y1="98" x2="90" y2="106" />
          <text x="60" y="100" textAnchor="middle">Ø</text>
        </g>
      </>
    ),
  },
];

export const SPEC_ROWS = [
  ["MS ANGLES", "25×25×3 — 100×100×10 MM", "IS 2062 E250"],
  ["MS CHANNELS", "75×40 — 400×100 MM", "IS 2062 E250"],
  ["SHEETS", "HR 1.6—25 · CR 0.3—3 · GP/GC · METRO", "IS 1079 / 513 / 277"],
  ["PLATES", "5—100 MM · 1250/1500/2000/2500 W", "IS 2062 E250 / E350"],
  ["ROUND BARS", "6—100 MM Ø", "MS / EN8"],
  ["TMT BARS", "8—32 MM Ø · Fe500 / Fe550", "IS 1786"],
  ["FLATS", "20×3 — 100×12 MM", "MS"],
  ["SQUARE BARS", "8—50 MM", "MS"],
  ["PIPES", "15—200 MM NB · ROUND & SQUARE", "IS 1239 / 3589"],
];
